import React, { ReactNode } from 'react'
import { Wrapper, TableHeader } from './styles'

import Item from './Item'
import Preloader from '../../Common/Preloader'

import { ListItem, Box } from '@material-ui/core'
import { ISpin } from '../../../interfaces'
import { Pagination } from '@material-ui/lab'
import { useSelector } from 'react-redux'
import { tableSelector } from '../../../redux/tableReducer'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface SpinsListProps {
  session_id: number
  loading?: boolean
  scroll?: boolean
  striped?: boolean
  spins?: ISpin[]
  fetch: (id: number, page: number, limit: number) => void
}

const SpinsList: React.FC<SpinsListProps> = ({ session_id, loading, spins = [], fetch }) => {
  const history = useHistory()
  const location = useLocation()
  const [t] = useTranslation()

  React.useEffect(() => {
    session_id && fetch(session_id, 1, 20)
    // eslint-disable-next-line
  }, [])

  const renderList = () => {
    return spins && spins.map((item, id) => {
      const operationColor = (id: number, balance_start: number, balance_end: number) => {
        const evenId = id % 2 === 0
        if (balance_start !== balance_end) {
          if (evenId) {
            return balance_start > balance_end ? '#a9c477' : '#de7d55'
          } else {
            return balance_start > balance_end ? '#87b03b57' : '#ffd8c7'
          }
        } else {
          if (evenId) {
            return '#eee'
          } else {
            return '#fafafa'
          }
        }
      }
      return (
        <React.Fragment key={id}>
          <Item
            item={item}
            bg={operationColor(id, Number(item.balance_start), Number(item.balance_end))}
          />
        </React.Fragment>
      )
    })
  }
  interface TcProps {
    children: ReactNode
  }
  const Tc: React.FC<TcProps> = ({ children }) => {
    return (
      <ListItem component="span" style={{ justifyContent: 'center', textAlign: 'center' }}>
        {children}
      </ListItem>
    )
  }

  const {
    spins: { countPage },
  } = useSelector(tableSelector)

  const query = new URLSearchParams(location.search)
  const spins_page = Number(query.get('spins_page'))
  const [page, setPage] = React.useState(spins_page ? spins_page : 1)
  React.useEffect(() => {
    fetch(session_id, page, 20)
    // eslint-disable-next-line
  }, [page])
  React.useEffect(() => {
    setPage(Number(spins_page))
    // eslint-disable-next-line
  }, [spins_page])

  return (
    <>
      <Wrapper>
        {/* <Box display="flex" justifyContent="space-between">
        <h3>{title}</h3>
      </Box> */}
        <div style={{ minWidth: '700px' }}>
          <TableHeader style={{ fontSize: '75%' }}>
            <Tc>#</Tc>
            <Tc>{t('ru.spins.fields.type')}</Tc>
            <Tc>{t('ru.spins.fields.balance_start')}</Tc>
            <Tc>{t('ru.spins.fields.balance_end')}</Tc>
            <Tc>{t('ru.spins.fields.lines')}</Tc>
            <Tc>{t('ru.spins.fields.bet')}</Tc>
            <Tc>{t('ru.spins.fields.win')}</Tc>
            <Tc>{t('ru.spins.fields.created_at')}</Tc>
          </TableHeader>
          <ul className={'spins'}>{loading ? <Preloader absolute={false} /> : renderList()}</ul>
        </div>
      </Wrapper>
      <Box
        display="flex"
        justifyContent="center"
        style={{ margin: '10px auto', width: '100%' }}
      >
        <Pagination
          variant="outlined"
          shape="rounded"
          siblingCount={0}
          count={Number(countPage)}
          page={Number(page)}
          onChange={(e, value) => {
            query.set('spins_page', String(value))
            history.push({
              pathname: location.pathname,
              search: query.toString(),
            })
            // setPage(value)
          }}
        />
      </Box>
    </>
  )
}

export default SpinsList
